import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../shared/components/CustomButton';
import PageLoader from '../../shared/components/PageLoader/PageLoader';
import PATH from '../../shared/constants/path.const';
import { getColors } from '../../theme';

const colors = getColors();
function NotFoundPage() {
  const { colorShades } = colors;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PATH.AUTH.LOGIN);
    window.location.reload();
  };

  return (
    <PageLoader>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          inset: 0,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: '40px' }}>
            <b>Something&#39;s Wrong here...</b>
          </Typography>
          <Typography variant="h5" sx={{ m: '14px' }}>
            The link you followed may be broken or the page may no longer exist. Please go back to
            the home page
          </Typography>
          <Box style={{ mt: '100px' }}>
            <CustomButton
              onClick={handleClick}
              sx={{
                color: colorShades.pureWhite,
                border: 'none',
                padding: '10px 20px',
                cursor: 'pointer',
              }}
            >
              Go to Home
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </PageLoader>
  );
}

export default NotFoundPage;
